import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { GlobalTrendsService } from './globaltrends.service';
import { GlobalTrendsRequest, portfolio, distribution } from './globaltrends-request';
import { GlobalTrends } from './globaltrends';
import { DataPoint } from './datapoint';
import { ActivatedRoute, Params } from '@angular/router';
import { last } from '@angular/router/src/utils/collection';



@Component({
    templateUrl: 'globaltrends.component.html'
})
export class GlobalTrendsComponent implements OnInit {
    histGeneExample = '';
    rankGeneExample = '';
    histGeneExampleList = [];

    mgInfo: GlobalTrends[];
    sgInfo: GlobalTrends[];
    todaysDate = new Date();
    isGenomeValueReady = true;
    isFullAccess = true;
    loadingTrends = false;
    isInformationEnabled = false;
    isTopTrendsDataSetLoading = false;
    isTopTrendsFirstQuery = true;
    topTrendsRankChartLoading = false;
    topTrendsTimeChartLoading = false;
    chartLabel: string;
    isMgChart = true;
    isNetworkChart = true;
    isCountryChart = true;
    isSgChart = true;
    portfolio: portfolio;
    distribution: distribution;
    topFirstQuery = true;
    isDatasetBeingLoaded = false;
    isTopTrendsDataReady = false;
    isHistDatasetBeingLoaded = false;
    isTopTrendsDisplayChartEnabled = false;

    isDisplayChartEnabled = false;
    isHistDisplayChartEnabled = false;
    isHistChartReady = false;

    isTopDisplayChartEnabled = false;

    numberOfSuccessDataSet: number;
    numberOfHistSuccessDataSet = 0;

    isMgChartReady = false;
    isNetworkChartReady = false;
    isCountryChartReady = false;
    isSgChartReady = false;

    loadingTopBottom = false;
    filterChartGeneType = 'All';
    filterHistPortolio = 'Please Select Portfolio';
    filterWeekNumber = 28;
    filterTopNumber = 10;
    filterDateFrom = '2017-09-01';
    filterDateTo = '2017-09-14';
    filterAggregation = 'sum';
    filterDistribution = 'Top:20%';
    filterMarket = 'United States';
    filterOverviewGeneType = 'Please Select Type';
    filterOverviewGeneValue = 'Please Select Value';
    geneOverviewValueList = [];
    filterOverviewGeneTypeList = [];
    filterHistDateType = 'daily';

    filterHistDateFrom = '2017-09-01';
    filterHistDateTo = '2017-09-14';
    filterHistMarket = 'Please Select Market';
    filterHistAggregation = 'mean';
    filterGeneValue = 'Please Select Value';
    filterGeneType = 'Please Select Type';

    filterHistDistribution = '100%';
    filterTopDistribution = '100%';
    filterTopDateFrom = '2017-09-01';
    filterTopDateTo = '2017-09-14';
    filterTopAggregation = 'mean';
    filterTopGeneValue = 'Please Select Value';
    filterTopGeneType = 'Please Select Type';

    firstQuery = true;

    isDexc = true;
    isHistDexc = true;
    filterHistGeneType = 'Please Select Type';
    filterHistGeneValue = 'Please Select Value';
    geneHistValueList = [];


    filterTopSegGeneType = 'Please Select Type';
    filterTopSegGeneValue = 'Please Select Value';
    geneTopSegValueList = [];


    filterHistMarketList = [];
    filterGeneValueList = [];
    filterGeneTypeList = [];

    filterSegGeneValueList = [];
    filterSegGeneTypeList = [];
    filterOverviewSegGeneValueList = [];
    filterOverviewSegGeneTypeList = [];

    filterOverviewDistributionList = [];
    filterHistDistributionList = [];



    geneValueListOfList: any[][] = [];
    geneSegValueListOfList: any[][] = [];
    geneOverviewSegValueListOfList: any[][] = [];

    isHistDistribution = false;

    gtType = 'overview';

    onlyBarChartAllowed = false;
    filterOverviewMarketList: any[] = [];

    gtRequest: GlobalTrendsRequest;
    gtDataMG: GlobalTrends[];
    gtDataNetwork: GlobalTrends[];
    gtDataCountry: GlobalTrends[];
    gtDataSG: GlobalTrends[];
    gtDataHistorical: GlobalTrends[];

    gtDataTopTime: GlobalTrends[];
    gtDataTopRank: GlobalTrends[];


    histDatasetList: any[] = [];
    overviewDatasetList: any[] = [];
    overviewDateFromList: any[] = [];
    overviewDateToList: any[] = [];

    weekList: any[];
    marketList: GlobalTrends[];
    countryList: GlobalTrends[];
    mainRegionList: GlobalTrends[];
    subRegionList: GlobalTrends[];

    geneValueList: GlobalTrends[];
    portfolioList: GlobalTrends[];

    geneTopValueList: GlobalTrends[];



    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    disabled = false;
    mainGenreChartLoading = false;
    networkChartLoading = false;
    countryChartLoading = false;
    subgenreChartLoading = false;
    historicalChartLoading = false;

    isOverviewDistribution = false;

    public status: { isopen: boolean } = { isopen: false };

    public toggled(open: boolean): void {
    }

    public toggleDropdown($event: MouseEvent): void {
        this.status.isopen = !this.status.isopen;
    }

    public doughnutChartLabels: string[];
    public doughnutChartData: number[];
    public doughnutChartType: string = 'doughnut';

    // Pie
    public pieChartLabels: string[];
    public pieChartData: number[];
    public pieChartType: string = 'bar';

    // Radar
    public radarChartLabels: string[];

    public radarChartData: any = [
        { data: [65, 59, 90, 81, 56, 55, 40], label: 'Series A' }
    ];
    public radarChartType: string = 'radar';


    // barChart
    public mgChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            xAxes: [{
                ticks: {
                    beginAtZero: true,
                    callback: function (value, index, values) {
                        if (parseInt(value) >= 1000000) {
                            return (Math.round(value / 10000) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'M';
                        } else if (parseInt(value) >= 1000) {
                            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        } else {
                            return (Math.round(value * 100) / 100).toString();
                        }
                    }
                }
            }]
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    const allData = data.datasets[tooltipItem.datasetIndex].data;
                    const tooltipLabel = data.labels[tooltipItem.index];
                    const tooltipData = allData[tooltipItem.index];
                    let total = 0;
                    let tooltipDataFormatted;
                    for (const i in allData) {
                        total += allData[i];
                    }
                    if (tooltipData > 1000000) {
                        tooltipDataFormatted = Math.round(tooltipData / 10000) / 100 + ' Million';
                    } else if (tooltipData > 1000) {
                        tooltipDataFormatted = tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    } else {
                        tooltipDataFormatted = (Math.round(tooltipData * 100) / 100).toString();
                    }
                    const tooltipPercentage = Math.round((tooltipData / total) * 100);
                    return tooltipLabel + ': ' + tooltipDataFormatted
                        + ' (' + tooltipPercentage + '% of Top 10)';
                }
            }
        }
    };
    public mgChartLabels: string[] = [];
    public mgChartType: string = 'horizontalBar';
    public mgChartLegend: boolean = false;
    public mgChartData: any[] = [];
    //
    public networkChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            xAxes: [{
                ticks: {
                    beginAtZero: true,
                    callback: function (value, index, values) {
                        if (parseInt(value) >= 1000000) {
                            return (Math.round(value / 10000) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'M';
                        } else if (parseInt(value) >= 1000) {
                            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        } else {
                            return (Math.round(value * 100) / 100).toString();
                        }
                    }
                }
            }]
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    const allData = data.datasets[tooltipItem.datasetIndex].data;
                    const tooltipLabel = data.labels[tooltipItem.index];
                    const tooltipData = allData[tooltipItem.index];
                    let total = 0;
                    let tooltipDataFormatted;
                    for (const i in allData) {
                        total += allData[i];
                    }
                    if (tooltipData > 1000000) {
                        tooltipDataFormatted = Math.round(tooltipData / 10000) / 100 + ' Million';
                    } else if (tooltipData > 1000) {
                        tooltipDataFormatted = tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    } else {
                        tooltipDataFormatted = (Math.round(tooltipData * 100) / 100).toString();
                    }
                    const tooltipPercentage = Math.round((tooltipData / total) * 100);
                    return tooltipLabel + ': ' + tooltipDataFormatted
                        + ' (' + tooltipPercentage + '% of Top 10)';
                }
            }
        }
    };
    public networkChartLabels: string[];
    public networkChartData: any[];
    public networkChartLegend: boolean = true;
    public networkChartType: string = 'horizontalBar';

    // barChart
    public countryChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    const allData = data.datasets[tooltipItem.datasetIndex].data;
                    const tooltipLabel = data.labels[tooltipItem.index];
                    const tooltipData = allData[tooltipItem.index];
                    let total = 0;
                    let tooltipDataFormatted;
                    for (const i in allData) {
                        total += allData[i];
                    }
                    if (tooltipData > 1000000) {
                        tooltipDataFormatted = Math.round(tooltipData / 10000) / 100 + ' Million';
                    } else if (tooltipData > 1000) {
                        tooltipDataFormatted = tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    } else {
                        tooltipDataFormatted = (Math.round(tooltipData * 100) / 100).toString();
                    }
                    const tooltipPercentage = Math.round((tooltipData / total) * 100);
                    return tooltipLabel + ': ' + tooltipDataFormatted
                        + ' (' + tooltipPercentage + '% of Top 10)';
                }
            }
        }
    };
    public countryChartLabels: string[] = [];
    public countryChartType: string = 'pie';
    public countryChartLegend: boolean = true;
    public countryChartData: any[] = [];



    // barChart
    public sgChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    const allData = data.datasets[tooltipItem.datasetIndex].data;
                    const tooltipLabel = data.labels[tooltipItem.index];
                    const tooltipData = allData[tooltipItem.index];
                    let total = 0;
                    let tooltipDataFormatted;
                    for (const i in allData) {
                        total += allData[i];
                    }
                    if (tooltipData > 1000000) {
                        tooltipDataFormatted = Math.round(tooltipData / 10000) / 100 + ' Million';
                    } else if (tooltipData > 1000) {
                        tooltipDataFormatted = tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    } else {
                        tooltipDataFormatted = (Math.round(tooltipData * 100) / 100).toString();
                    }
                    const tooltipPercentage = Math.round((tooltipData / total) * 100);
                    return tooltipLabel + ': ' + tooltipDataFormatted
                        + ' (' + tooltipPercentage + '% of Top 10)';
                }
            }
        }
    };
    public sgChartLabels: string[] = [];
    public sgChartType: string = 'pie';
    public sgChartLegend: boolean = false;
    public sgChartData: any[] = [];

    // top rank
    public topRankData: Array<any> = [];
    public topRankLabels: Array<any> = [];
    isTopRankChartReady = false;
    public topRankOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            xAxes: [{
                ticks: {
                    beginAtZero: true
                },
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Demand Expression per Capita'
                }
            }]
        }
    };


    // top timeseries
    public topTimeData: Array<any> = [];
    public topTimeLabels: Array<any> = [];
    isTopTimeChartReady = false;
    public topTimeChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    const allData = data.datasets[tooltipItem.datasetIndex].data;
                    const tooltipLabel = data.labels[tooltipItem.index];
                    const tooltipData = allData[tooltipItem.index];
                    let tooltipDataFormatted;

                    if (tooltipData > 1000000) {
                        tooltipDataFormatted = Math.round(tooltipData / 10000) / 100 + ' Million';
                    } else {
                        tooltipDataFormatted = tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                    return tooltipLabel + ': ' + tooltipDataFormatted;
                }
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    callback: function (value, index, values) {
                        if (parseInt(value) >= 1000000) {
                            return (Math.round(value / 10000) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'M';
                        } else if (parseInt(value) >= 1000) {
                            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        } else {
                            return (Math.round(value * 100) / 100).toString();
                        }
                    }
                },
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Demand Expression Per Capita'
                }
            }]
        }
    };


    // lineChart
    public lineChartData: Array<any> = [];
    public lineChartLabels: Array<any> = [];
    public lineChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    const allData = data.datasets[tooltipItem.datasetIndex].data;
                    const tooltipLabel = data.labels[tooltipItem.index];
                    const tooltipData = allData[tooltipItem.index];
                    let tooltipDataFormatted;

                    if (tooltipData > 1000000) {
                        tooltipDataFormatted = Math.round(tooltipData / 10000) / 100 + ' Million';
                    } else if (tooltipData > 1000) {
                        tooltipDataFormatted = tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    } else {
                        tooltipDataFormatted = tooltipData;
                    }
                    return tooltipLabel + ': ' + tooltipDataFormatted;
                }
            }
        },
        scales: {
            xAxes: [{
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Date'
                }
            }],
            yAxes: [{
                ticks: {
                    callback: function (value, index, values) {
                        if (parseInt(value) >= 1000000) {
                            return (Math.round(value / 10000) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'M';
                        } else if (parseInt(value) >= 1000) {
                            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        } else {
                            return (Math.round(value * 100) / 100).toString();
                        }
                    }
                },
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Demand Expression'
                }
            }]
        }
    };

    public overviewlineChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        maintainAspectRatio: false

    };
    public lineChartColours: Array<any> = [
        { // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    ];
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';
    public lineChartTypeTop: string = 'line';
    public lineChartTypeBottom: string = 'line';

    public lineChartDataTop: Array<any> = [];
    public lineChartDataBottom: Array<any> = [];

    public lineChartOverviewDataTop: Array<any> = [];
    public lineChartOverviewDataBottom: Array<any> = [];

    constructor(private _service: NotificationsService, private globaltrendsService: GlobalTrendsService, private route: ActivatedRoute) { }


    ngOnInit() {
        {
            this.globaltrendsService.getGeneInfo('market')
                .then(res => this.marketList = res.result)
                .then(res => {
                    // country transformation
                    this.countryList = this.marketList.filter(x => x.market.startsWith('country'));
                    this.countryList.forEach(x => x.market = x.market.replace('country:', ''));

                    // sub_region transformation
                    this.subRegionList = this.marketList.filter(x => x.market.startsWith('sub_region'));
                    this.subRegionList.forEach(x => x.market = x.market.replace('sub_region:', ''));

                    // main_region transformation
                    this.mainRegionList = this.marketList.filter(x => x.market.startsWith('major_region'));
                    this.mainRegionList.forEach(x => x.market = x.market.replace('major_region:', ''));
                })
                .then(res => { this.updateGlobalTrends(); })
                .catch(error => this.errorHandler(error));
        }
    }
    clickAddDataSet() {
        if (this.histDatasetList.includes(2) || this.filterHistPortolio !== 'Please Select Portfolio') {
            this.errorHandler('Please remove portfolio to add dataset');
        }
        else if (this.histDatasetList.length > 3) {
            this.errorHandler('You cannot add more dataset');
        } else {
            this.histGeneExampleList.push('');
            this.isHistDisplayChartEnabled = false;
            this.isHistDatasetBeingLoaded = false;
            this.filterHistMarketList.push(this.filterHistMarket);
            this.histDatasetList.push(1);
            this.filterGeneTypeList.push('Please Select Type');
            this.filterGeneValueList.push('Please Select Value');
            this.filterSegGeneTypeList.push('Please Select Type');
            this.filterSegGeneValueList.push('Please Select Value');
            this.geneSegValueListOfList.push([]);
            this.geneValueListOfList.push([]);
            this.filterHistDistributionList.push(this.filterHistDistribution);

        }
    }

    clickOverviewAddDataSet() {
        if (this.overviewDatasetList.length > 3) {
            this.errorHandler('You cannot add more dataset');
        } else {
            this.isDatasetBeingLoaded = false;
            this.filterOverviewMarketList.push(this.filterMarket);
            this.overviewDatasetList.push(1);
            this.overviewDateToList.push(this.filterDateTo);
            this.overviewDateFromList.push(this.filterDateFrom);
            this.filterOverviewSegGeneTypeList.push('Please Select Type');
            this.filterOverviewSegGeneValueList.push('Please Select Value');
            this.filterOverviewDistributionList.push(this.filterDistribution);
            this.geneOverviewSegValueListOfList.push([]);
        }
    }
    clickOverviewDeleteDataSet(index: number) {
        this.isDatasetBeingLoaded = false;
        this.overviewDatasetList.splice(index, 1);
        this.filterOverviewMarketList.splice(index, 1);
        this.overviewDateToList.splice(index, 1);
        this.overviewDateFromList.splice(index, 1);
        this.geneOverviewSegValueListOfList.splice(index, 1);
        this.filterOverviewSegGeneTypeList.splice(index, 1);
        this.filterOverviewSegGeneValueList.splice(index, 1);
        this.filterOverviewDistributionList.splice(index, 1);

    }

    clickOverviewResetDataSet(index: number) {
        this.filterDateFrom = '2017-09-01';
        this.filterDateTo = '2017-09-14';
        this.filterAggregation = 'sum';
        this.filterDistribution = 'Top:20%';
        this.filterMarket = 'United States';
        this.filterOverviewGeneType = 'Please Select Type';
        this.filterOverviewGeneValue = 'Please Select Value';
        this.filterChartGeneType = 'All';

        this.overviewDatasetList = [];
        this.filterOverviewMarketList = [];
        this.overviewDateToList = [];
        this.overviewDateFromList = [];
        this.filterOverviewGeneValue = 'Please Select Value';
        this.isDisplayChartEnabled = false;
        this.geneOverviewSegValueListOfList = [];
        this.filterOverviewSegGeneTypeList = [];
        this.filterOverviewSegGeneValueList = [];
        this.filterOverviewDistributionList = [];
        this.numberOfSuccessDataSet = 1;

    }

    clickAddPortofolioHist() {
        if (this.histDatasetList.includes(1)) {
            this.errorHandler('Please remove all dataset to compare with Portfolio');
        } else {
            this.histDatasetList.push(2);
            this.getGtHistorical();
        }
    }
    clickDeleteDataSet(index: number) {
        this.isHistDisplayChartEnabled = false;
        this.isHistDatasetBeingLoaded = false;
        this.histDatasetList.splice(index, 1);
        this.filterHistMarketList.splice(index, 1);
        this.filterGeneTypeList.splice(index, 1);
        this.filterGeneValueList.splice(index, 1);
        this.geneValueListOfList.splice(index, 1);
        this.geneSegValueListOfList.splice(index, 1);
        this.filterSegGeneTypeList.splice(index, 1);
        this.filterSegGeneValueList.splice(index, 1);
        this.filterHistDistributionList.splice(index, 1);

    }

    clickResetDataSet(index: number) {
        this.isHistDisplayChartEnabled = false;
        this.filterHistDateFrom = '2017-09-01';
        this.filterHistDateTo = '2017-09-14';
        this.filterHistMarket = 'Please Select Market';
        this.filterHistAggregation = 'sum';
        this.filterGeneValue = 'Please Select Value';
        this.filterGeneType = 'Please Select Type';
        this.filterHistDateType = 'daily';
        this.filterHistGeneType = 'Please Select Type';
        this.filterHistGeneValue = 'Please Select Value';
        this.filterHistDistribution = '100%';


        this.histGeneExampleList = [];
        this.histDatasetList = [];
        this.filterHistMarketList = [];
        this.filterGeneTypeList = [];
        this.filterGeneValueList = [];
        this.geneValueListOfList = [];
        this.geneSegValueListOfList = [];
        this.filterSegGeneTypeList = [];
        this.filterSegGeneValueList = [];
        this.filterHistDistributionList = [];
        this.numberOfHistSuccessDataSet = 1;

    }



    displayToChart() {
        if (this.isDisplayChartEnabled === true && this.numberOfSuccessDataSet === this.overviewDatasetList.length + 1) {
            this.isMgChart = false;
            this.isNetworkChart = false;
            this.isCountryChart = false;
            this.isSgChart = false;
            this.mainGenreChartLoading = false;
            this.networkChartLoading = false;
            this.countryChartLoading = false;
            this.subgenreChartLoading = false;
            this.isMgChartReady = false;
            this.isSgChartReady = false;
            this.isNetworkChartReady = false;
            this.isCountryChartReady = false;
            this.isInformationEnabled = false;

            if (this.filterChartGeneType === 'All') {
                this.isMgChart = true;
                this.isNetworkChart = true;
                this.isCountryChart = true;
                this.isSgChart = true;
                this.mainGenreChartLoading = true;
                this.countryChartLoading = true;
                this.subgenreChartLoading = true;
                this.networkChartLoading = true;
                this.getGtOverview('genre');
                this.getGtOverview('subgenre');
                this.getGtOverview('country');
                this.getGtOverview('network');
                this.clickInformation('genre');
                this.clickInformation('subgenre');

            } else if (this.filterChartGeneType === 'Main Genre') {
                this.isMgChart = true;
                this.mainGenreChartLoading = true;
                this.getGtOverview('genre');
                this.clickInformation('genre');
            } else if (this.filterChartGeneType === 'Sub Genre') {
                this.isSgChart = true;
                this.countryChartLoading = true;
                this.getGtOverview('subgenre');
                this.clickInformation('subgenre');
            } else if (this.filterChartGeneType === 'Orig. Country') {
                this.isCountryChart = true;
                this.subgenreChartLoading = true;
                this.getGtOverview('country');
            } else if (this.filterChartGeneType === 'Orig. Network') {
                this.isNetworkChart = true;
                this.networkChartLoading = true;
                this.getGtOverview('network');
            }
        }
    }


    clickChartType(dataType: string, option: number) {
        let chartType;
        let chartLegend;
        const chartOptionElse: any = {
            scaleShowVerticalLines: false,
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        const allData = data.datasets[tooltipItem.datasetIndex].data;
                        const tooltipLabel = data.labels[tooltipItem.index];
                        const tooltipData = allData[tooltipItem.index];
                        let total = 0;
                        let tooltipDataFormatted;
                        for (const i in allData) {
                            total += allData[i];
                        }
                        if (tooltipData > 1000000) {
                            tooltipDataFormatted = Math.round(tooltipData / 10000) / 100 + ' Million';
                        } else if (tooltipData > 1000) {
                            tooltipDataFormatted = tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        } else {
                            tooltipDataFormatted = (Math.round(tooltipData * 100) / 100).toString();
                        }
                        const tooltipPercentage = Math.round((tooltipData / total) * 100);
                        return tooltipLabel + ': ' + tooltipDataFormatted
                            + ' (' + tooltipPercentage + '% of Top 10)';
                    }
                }
            }
        };

        const chartOptionBar: any = {
            scaleShowVerticalLines: false,
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function (value, index, values) {
                            if (parseInt(value) >= 1000000) {
                                return (Math.round(value / 10000) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'M';
                            } else if (parseInt(value) >= 1000) {
                                return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                            } else {
                                return (Math.round(value * 100) / 100).toString();
                            }
                        }
                    }
                }]
            },
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        const allData = data.datasets[tooltipItem.datasetIndex].data;
                        const tooltipLabel = data.labels[tooltipItem.index];
                        const tooltipData = allData[tooltipItem.index];
                        let total = 0;
                        let tooltipDataFormatted;
                        for (const i in allData) {
                            total += allData[i];
                        }
                        if (tooltipData > 1000000) {
                            tooltipDataFormatted = Math.round(tooltipData / 10000) / 100 + ' Million';
                        } else if (tooltipData > 1000) {
                            tooltipDataFormatted = tooltipData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        } else {
                            tooltipDataFormatted = (Math.round(tooltipData * 100) / 100).toString();
                        }
                        const tooltipPercentage = Math.round((tooltipData / total) * 100);
                        return tooltipLabel + ': ' + tooltipDataFormatted
                            + ' (' + tooltipPercentage + '% of Top 10)';
                    }
                }
            }
        };

        if (option === 1) {
            chartType = 'horizontalBar';
            if (this.filterDistribution === 'True') {
                chartLegend = true;
            } else {
                chartLegend = false;
            }
        }
        else if (option === 2) {
            chartType = 'pie';
            chartLegend = true;
        }
        else if (option === 3) {
            chartType = 'polarArea';
            chartLegend = true;

        }


        if (dataType === 'mg') {
            this.mainGenreChartLoading = true;
            this.isMgChartReady = false;
            this.mgChartType = chartType;
            this.mgChartLegend = chartLegend;
            if (option === 1) {
                this.mgChartOptions = chartOptionBar;
            } else if (option === 2) {
                this.mgChartOptions = chartOptionElse;

            } else if (option === 3) {
                this.mgChartOptions = chartOptionElse;
            }
            setTimeout(() => {
                this.isMgChartReady = true;
                this.mainGenreChartLoading = false;
            }, 2);

        } else if (dataType === 'network') {
            this.networkChartLoading = true;
            this.networkChartType = chartType;
            this.networkChartLegend = chartLegend;
            this.networkChartLoading = false;
            if (option === 1) {
                this.networkChartOptions = chartOptionBar;
            } else if (option === 2) {
                this.networkChartOptions = chartOptionElse;

            } else if (option === 3) {
                this.networkChartOptions = chartOptionElse;
            }
            setTimeout(() => {
                this.isNetworkChartReady = true;
                this.networkChartLoading = false;
            }, 2);
        } else if (dataType === 'country') {
            this.countryChartLoading = true;
            this.countryChartType = chartType;
            this.countryChartLegend = chartLegend;
            this.countryChartLoading = false;
            if (option === 1) {
                this.countryChartOptions = chartOptionBar;
            } else if (option === 2) {
                this.countryChartOptions = chartOptionElse;

            } else if (option === 3) {
                this.countryChartOptions = chartOptionElse;
            }
            setTimeout(() => {
                this.isCountryChartReady = true;
                this.countryChartLoading = false;
            }, 2);
        } else if (dataType === 'sg') {
            this.subgenreChartLoading = true;
            this.sgChartType = chartType;
            this.sgChartLegend = chartLegend;
            this.subgenreChartLoading = false;
            if (option === 1) {
                this.sgChartOptions = chartOptionBar;
            } else if (option === 2) {
                this.sgChartOptions = chartOptionElse;

            } else if (option === 3) {
                this.sgChartOptions = chartOptionElse;
            }

            setTimeout(() => {
                this.isSgChartReady = true;
                this.subgenreChartLoading = false;
            }, 2);
        }
    }


    getGeneValues(type: string) {
        this.filterGeneValue = 'Please Select Value';
        if (type !== 'Please Select Type') {
            this.isGenomeValueReady = false;
            this.histGeneExample = '';
            const gtRequest = new GlobalTrendsRequest();
            let genetype = '';
            if (type === 'Main Genre') {
                genetype = 'genre';
            } else if (type === 'Sub Genre') {
                genetype = 'subgenre';
            } else if (type === 'Orig. Country') {
                genetype = 'country';
            } else if (type === 'Orig. Network') {
                genetype = 'network';
            }
            gtRequest.genetype = genetype;
            return this.globaltrendsService
                .getGeneValue(gtRequest)
                .then(res => {
                    this.geneValueList = res.result;
                    this.isGenomeValueReady = true;
                    this.geneValueList.sort((leftSide, rightSide): number => {
                        if (leftSide.genevalue.toLowerCase() > rightSide.genevalue.toLowerCase()) { return 1; };
                        if (leftSide.genevalue.toLowerCase() < rightSide.genevalue.toLowerCase()) { return -1; };
                        return 0;
                    });
                })
                .catch(error => this.errorHandler(error));
        }
    }

    getGeneExample(type: string) {
        this.histGeneExample = '';
        if (type !== 'Please Select Value' && this.filterGeneType !== 'Orig. Country' && this.filterGeneType !== 'Orig. Network') {
            return this.globaltrendsService
                .getGenomeExample(type)
                .then(res => {
                    this.histGeneExample = res.value;
                })
                .catch(error => this.errorHandler(error));
        }
    }


    getRankGeneExample(type: string) {
        this.rankGeneExample = '';
        if (type !== 'Please Select Value' && this.filterTopGeneType !== 'Orig. Country' && this.filterTopGeneType !== 'Orig. Network') {
            return this.globaltrendsService
                .getGenomeExample(type)
                .then(res => {
                    this.rankGeneExample = res.value;
                })
                .catch(error => this.errorHandler(error));
        }
    }


    getGeneExampleList(index: number, type: string) {
        this.histGeneExampleList[index] = '';
        if (type !== 'Please Select Value' && this.filterGeneTypeList[index] !== 'Orig. Country' && this.filterGeneTypeList[index] !== 'Orig. Network') {
            return this.globaltrendsService
                .getGenomeExample(type)
                .then(res => {
                    this.histGeneExampleList[index] = res.value;
                })
                .catch(error => this.errorHandler(error));
        }
    }

    getTopGeneValues(type: string) {
        this.filterTopGeneValue = 'Please Select Value';
        this.rankGeneExample = '';

        if (type !== 'Please Select Type') {

            this.isGenomeValueReady = false;
            const gtRequest = new GlobalTrendsRequest();
            let genetype = '';
            if (type === 'Main Genre') {
                genetype = 'genre';
            } else if (type === 'Sub Genre') {
                genetype = 'subgenre';
            } else if (type === 'Orig. Country') {
                genetype = 'country';
            } else if (type === 'Orig. Network') {
                genetype = 'network';
            }
            gtRequest.genetype = genetype;
            return this.globaltrendsService
                .getGeneValue(gtRequest)
                .then(res => {
                    this.isGenomeValueReady = true;

                    this.geneTopValueList = res.result;

                    this.geneTopValueList.sort((leftSide, rightSide): number => {
                        if (leftSide.genevalue.toLowerCase() > rightSide.genevalue.toLowerCase()) { return 1; };
                        if (leftSide.genevalue.toLowerCase() < rightSide.genevalue.toLowerCase()) { return -1; };
                        return 0;
                    });
                })
                .catch(error => this.errorHandler(error));
        }
    }

    getOverviewGeneValues(type: string) {
        this.filterOverviewGeneValue = 'Please Select Value';
        if (type !== 'Please Select Type') {
            this.isGenomeValueReady = false;

            const gtRequest = new GlobalTrendsRequest();
            let genetype = '';
            if (type === 'Main Genre') {
                genetype = 'genre';
            } else if (type === 'Sub Genre') {
                genetype = 'subgenre';
            } else if (type === 'Orig. Country') {
                genetype = 'country';
            } else if (type === 'Orig. Network') {
                genetype = 'network';
            }
            gtRequest.genetype = genetype;
            return this.globaltrendsService
                .getGeneValue(gtRequest)
                .then(res => {
                    this.geneOverviewValueList = res.result;
                    this.geneOverviewValueList.sort((leftSide, rightSide): number => {
                        this.isGenomeValueReady = true;
                        if (leftSide.genevalue.toLowerCase() > rightSide.genevalue.toLowerCase()) { return 1; };
                        if (leftSide.genevalue.toLowerCase() < rightSide.genevalue.toLowerCase()) { return -1; };
                        return 0;
                    });
                })
                .catch(error => this.errorHandler(error));
        }
    }

    getHistGeneValues(type: string) {
        this.filterHistGeneValue = 'Please Select Value';
        if (type !== 'Please Select Type') {
            this.isGenomeValueReady = false;
            const gtRequest = new GlobalTrendsRequest();
            let genetype = '';
            if (type === 'Main Genre') {
                genetype = 'genre';
            } else if (type === 'Sub Genre') {
                genetype = 'subgenre';
            } else if (type === 'Orig. Country') {
                genetype = 'country';
            } else if (type === 'Orig. Network') {
                genetype = 'network';
            }
            gtRequest.genetype = genetype;
            return this.globaltrendsService
                .getGeneValue(gtRequest)
                .then(res => {
                    this.isGenomeValueReady = true;

                    this.geneHistValueList = res.result;
                    this.geneHistValueList.sort((leftSide, rightSide): number => {
                        if (leftSide.genevalue.toLowerCase() > rightSide.genevalue.toLowerCase()) { return 1; };
                        if (leftSide.genevalue.toLowerCase() < rightSide.genevalue.toLowerCase()) { return -1; };
                        return 0;
                    });
                })
                .catch(error => this.errorHandler(error));
        }
    }

    getTopSegGeneValues(type: string) {
        this.filterTopSegGeneValue = 'Please Select Value';
        if (type !== 'Please Select Type') {
            this.isGenomeValueReady = false;
            const gtRequest = new GlobalTrendsRequest();
            let genetype = '';
            if (type === 'Main Genre') {
                genetype = 'genre';
            } else if (type === 'Sub Genre') {
                genetype = 'subgenre';
            } else if (type === 'Orig. Country') {
                genetype = 'country';
            } else if (type === 'Orig. Network') {
                genetype = 'network';
            }
            gtRequest.genetype = genetype;
            return this.globaltrendsService
                .getGeneValue(gtRequest)
                .then(res => {
                    this.geneTopSegValueList = res.result;
                    this.geneTopSegValueList.sort((leftSide, rightSide): number => {
                        this.isGenomeValueReady = true;

                        if (leftSide.genevalue.toLowerCase() > rightSide.genevalue.toLowerCase()) { return 1; };
                        if (leftSide.genevalue.toLowerCase() < rightSide.genevalue.toLowerCase()) { return -1; };
                        return 0;
                    });
                })
                .catch(error => this.errorHandler(error));
        }
    }
    getSegGeneValuesFromList(index: number, type: string) {
        this.filterSegGeneValueList[index] = 'Please Select Value';
        if (type !== 'Please Select Type') {
            this.isGenomeValueReady = false;
            const gtRequest = new GlobalTrendsRequest();
            let genetype = '';
            if (type === 'Main Genre') {
                genetype = 'genre';
            } else if (type === 'Sub Genre') {
                genetype = 'subgenre';
            } else if (type === 'Orig. Country') {
                genetype = 'country';
            } else if (type === 'Orig. Network') {
                genetype = 'network';
            }
            gtRequest.genetype = genetype;
            return this.globaltrendsService
                .getGeneValue(gtRequest)
                .then(res => {
                    const geneValueList = res.result;
                    geneValueList.sort((leftSide, rightSide): number => {
                        this.isGenomeValueReady = true;

                        if (leftSide.genevalue.toLowerCase() > rightSide.genevalue.toLowerCase()) { return 1; };
                        if (leftSide.genevalue.toLowerCase() < rightSide.genevalue.toLowerCase()) { return -1; };
                        return 0;
                    });

                    this.geneSegValueListOfList[index] = geneValueList;
                })
                .catch(error => this.errorHandler(error));
        }
    }

    getOverviewSegGeneValuesFromList(index: number, type: string) {
        this.filterOverviewSegGeneValueList[index] = 'Please Select Value';
        if (type !== 'Please Select Type') {
            this.isGenomeValueReady = false;
            const gtRequest = new GlobalTrendsRequest();
            let genetype = '';
            if (type === 'Main Genre') {
                genetype = 'genre';
            } else if (type === 'Sub Genre') {
                genetype = 'subgenre';
            } else if (type === 'Orig. Country') {
                genetype = 'country';
            } else if (type === 'Orig. Network') {
                genetype = 'network';
            }
            gtRequest.genetype = genetype;
            return this.globaltrendsService
                .getGeneValue(gtRequest)
                .then(res => {
                    const geneValueList = res.result;
                    geneValueList.sort((leftSide, rightSide): number => {
                        this.isGenomeValueReady = true;

                        if (leftSide.genevalue.toLowerCase() > rightSide.genevalue.toLowerCase()) { return 1; };
                        if (leftSide.genevalue.toLowerCase() < rightSide.genevalue.toLowerCase()) { return -1; };
                        return 0;
                    });

                    this.geneOverviewSegValueListOfList[index] = geneValueList;
                })
                .catch(error => this.errorHandler(error));
        }
    }


    getGeneValuesFromList(index: number, type: string) {
        this.getGeneExampleList[index] = '';
        this.filterGeneValueList[index] = 'Please Select Value';
        if (type !== 'Please Select Type') {
            this.isGenomeValueReady = false;
            const gtRequest = new GlobalTrendsRequest();
            let genetype = '';
            if (type === 'Main Genre') {
                genetype = 'genre';
            } else if (type === 'Sub Genre') {
                genetype = 'subgenre';
            } else if (type === 'Orig. Country') {
                genetype = 'country';
            } else if (type === 'Orig. Network') {
                genetype = 'network';
            }
            gtRequest.genetype = genetype;
            return this.globaltrendsService
                .getGeneValue(gtRequest)
                .then(res => {
                    const geneValueList = res.result;
                    geneValueList.sort((leftSide, rightSide): number => {
                        this.isGenomeValueReady = true;

                        if (leftSide.genevalue.toLowerCase() > rightSide.genevalue.toLowerCase()) { return 1; };
                        if (leftSide.genevalue.toLowerCase() < rightSide.genevalue.toLowerCase()) { return -1; };
                        return 0;
                    });

                    this.geneValueListOfList[index] = geneValueList;
                })
                .catch(error => this.errorHandler(error));
        }
    }

    getGtHistorical() {
        if (this.filterGeneValue === 'Please Select Value' || this.filterHistMarket === 'Please Select Market'
            || this.filterHistMarketList.includes('Please Select Market')
            || this.filterGeneValueList.includes('Please Select Value')) {
            this.errorHandler('Please select Market and Genome Value');
        } else {
            let marketOk = true;
            let dateOk = true;
            const dateFrom = new Date(this.filterHistDateFrom);
            const dateTo = new Date(this.filterHistDateTo);
            if (dateFrom > dateTo) {
                dateOk = false;
            }
            if (dateTo > this.todaysDate) {
                dateOk = false;
            }

            if (this.isRegion(this.filterHistMarket) === 2) {
                const date1 = new Date(this.filterHistDateTo);
                const refinedDate = new Date(date1.setMonth(date1.getMonth() - 1));

                if (refinedDate > dateFrom) {
                    marketOk = false;
                }
            }
            else {
                if (this.isRegion(this.filterHistMarket) === 1) {
                    const date1 = new Date(this.filterHistDateTo);
                    const refinedDate = new Date(date1.setMonth(date1.getMonth() - 3));

                    if (refinedDate > dateFrom) {
                        marketOk = false;
                    }
                }
            }
            for (let i = 0; i < this.histDatasetList.length; i++) {
                if (this.isRegion(this.filterHistMarketList[i]) === 2) {
                    const date1 = new Date(this.filterHistDateTo);
                    const refinedDate = new Date(date1.setMonth(date1.getMonth() - 1));

                    if (refinedDate > dateFrom) {
                        marketOk = false;
                        break;
                    }
                } else {
                    if (this.isRegion(this.filterHistMarketList[i]) === 1) {
                        const date1 = new Date(this.filterHistDateTo);
                        const refinedDate = new Date(date1.setMonth(date1.getMonth() - 3));

                        if (refinedDate > dateFrom) {
                            marketOk = false;
                            break;
                        }
                    }
                }
            }

            if (dateOk === false) {
                this.errorHandler('Date Error: Please check the selected dates');
            } else if (marketOk === false) {
                this.errorHandler('Main Region maximum date range is 1 month. Sub Region maximum date range is 3 months');
            }
            else {
                if (this.firstQuery === true) {
                    this.firstQuery = false;
                }
                this.loadingTrends = true;

                this.isHistDisplayChartEnabled = false;
                this.isHistDexc = true;
                this.historicalChartLoading = false;
                this.isHistChartReady = false;
                this.numberOfHistSuccessDataSet = 0;
                const gtDeleteAllRequest = new GlobalTrendsRequest();
                gtDeleteAllRequest.action = 'delete_all';
                gtDeleteAllRequest.endpoint = 'historical';
                gtDeleteAllRequest.username = localStorage.getItem('user_id');
                this.globaltrendsService.createDataSet(gtDeleteAllRequest)
                    .then(res => {
                        this.prepareHistDataSet();
                    })
                    .catch(error => this.errorHandler(error));
            }
        }
    }


    getTopTrends() {
        if (this.filterTopGeneValue === 'Please Select Value') {
            this.errorHandler('Please select Genome Value');
        } else {
            const dateFrom = new Date(this.filterTopDateFrom);
            const dateTo = new Date(this.filterTopDateTo);

            const date1 = new Date(this.filterTopDateTo);
            const refinedDate = new Date(date1.setMonth(date1.getMonth() - 1));


            if (dateFrom > dateTo || dateTo > this.todaysDate) {
                this.errorHandler('Date Error: Please check the selected dates');
            } else if (refinedDate > dateFrom) {
                this.errorHandler('Maximum date range is 1 month');
            }
            else {
                if (this.topFirstQuery === true) {
                    this.topFirstQuery = false;
                }
                this.loadingTrends = true;

                this.isTopTrendsDataSetLoading = true;
                this.isTopTrendsDataReady = false;
                this.isTopRankChartReady = false;
                this.isTopTimeChartReady = false;
                this.isTopTrendsDisplayChartEnabled = false;

                this.isTopDisplayChartEnabled = false;


                const gtDeleteAllRequest = new GlobalTrendsRequest();
                gtDeleteAllRequest.action = 'delete_all';
                gtDeleteAllRequest.endpoint = 'historical';
                gtDeleteAllRequest.username = localStorage.getItem('user_id');
                this.globaltrendsService.createDataSet(gtDeleteAllRequest)
                    .then(res => {
                        const gtRequest = new GlobalTrendsRequest();
                        gtRequest.start_date = this.filterTopDateFrom;
                        gtRequest.end_date = this.filterTopDateTo;
                        gtRequest.endpoint = 'topmarket';
                        gtRequest.aggregation = this.filterTopAggregation;
                        gtRequest.dataset_type = 'topmarket';
                        gtRequest.action = 'create';
                        gtRequest.filter = [this.filterTopGeneValue];
                        gtRequest.top = 10; // TODO change this
                        gtRequest.username = localStorage.getItem('user_id');

                        if (this.filterTopSegGeneValue !== 'Please Select Value') {
                            this.portfolio = new portfolio();
                            this.portfolio.type = 'by_gene';
                            this.portfolio.value = [this.filterTopSegGeneValue];
                            gtRequest.portfolio = this.portfolio;
                        }


                        if (this.filterTopDistribution !== '100%') {
                            this.distribution = new distribution();
                            this.distribution.percentile = this.handleDistributionValue(this.filterTopDistribution);
                            this.distribution.type = this.handleDistributionType(this.filterTopDistribution);
                            gtRequest.distribution = this.distribution;
                        }


                        this.isTopTrendsFirstQuery = false;

                        this.globaltrendsService.createDataSet(gtRequest).then(res => {
                            this.isTopTrendsDataSetLoading = false;
                            this.isTopTrendsDataReady = true;
                            this.isTopTrendsDisplayChartEnabled = true;
                            this.loadingTrends = false;


                        });
                    })
                    .catch(error => this.errorHandler(error));
            }
        }
    }

    prepareHistDataSet() {
        const gtRequest = new GlobalTrendsRequest();
        this.isHistDatasetBeingLoaded = true;
        this.loadingTrends = true;

        gtRequest.start_date = this.filterHistDateFrom;
        gtRequest.end_date = this.filterHistDateTo;
        gtRequest.market = this.handleMarket(this.filterHistMarket);
        gtRequest.endpoint = 'historical';
        gtRequest.aggregation = this.filterHistAggregation;
        gtRequest.dataset_type = 'primary';
        gtRequest.action = 'create';
        gtRequest.time_tag = this.filterHistDateType;
        gtRequest.filter = [this.filterGeneValue];
        gtRequest.username = localStorage.getItem('user_id');


        if (this.filterHistGeneValue !== 'Please Select Value') {
            this.portfolio = new portfolio();
            this.portfolio.type = 'by_gene';
            this.portfolio.value = [this.filterHistGeneValue];
            gtRequest.portfolio = this.portfolio;
        }

        if (this.filterHistDistribution !== '100%') {
            this.distribution = new distribution();
            this.distribution.percentile = this.handleDistributionValue(this.filterHistDistribution);
            this.distribution.type = this.handleDistributionType(this.filterHistDistribution);
            gtRequest.distribution = this.distribution;
        }
        this.globaltrendsService.createDataSet(gtRequest)
            .then(res => {
                this.numberOfHistSuccessDataSet = this.numberOfHistSuccessDataSet + 1;
                this.isHistDisplayChartEnabled = true;
                this.loadingTrends = false;

            })
            .catch(error => this.errorHandler(error));

        for (let i = 0; i < this.histDatasetList.length; i++) {
            const gtExtraDataRequest = new GlobalTrendsRequest();
            gtExtraDataRequest.start_date = this.filterHistDateFrom;
            gtExtraDataRequest.end_date = this.filterHistDateTo;
            gtExtraDataRequest.market = this.handleMarket(this.filterHistMarketList[i]);
            gtExtraDataRequest.endpoint = 'historical';
            gtExtraDataRequest.aggregation = this.filterHistAggregation;
            gtExtraDataRequest.dataset_type = '' + i;
            gtExtraDataRequest.action = 'create';
            gtExtraDataRequest.time_tag = this.filterHistDateType;
            gtExtraDataRequest.filter = [this.filterGeneValueList[i]];
            gtExtraDataRequest.username = localStorage.getItem('user_id');

            if (this.filterSegGeneValueList[i] !== 'Please Select Value') {
                this.portfolio = new portfolio();
                this.portfolio.type = 'by_gene';
                this.portfolio.value = [this.filterSegGeneValueList[i]];
                gtExtraDataRequest.portfolio = this.portfolio;
            }

            if (this.filterHistDistributionList[i] !== '100%') {
                this.distribution = new distribution();
                this.distribution.percentile = this.handleDistributionValue(this.filterHistDistributionList[i]);
                this.distribution.type = this.handleDistributionType(this.filterHistDistributionList[i]);
                gtExtraDataRequest.distribution = this.distribution;
            }

            this.globaltrendsService.createDataSet(gtExtraDataRequest)
                .then(res => {
                    this.numberOfHistSuccessDataSet = this.numberOfHistSuccessDataSet + 1;
                    this.isHistDisplayChartEnabled = true;
                    this.loadingTrends = false;


                })
                .catch(error => this.errorHandler(error)); ;
        }
    }

    clickTopTrendsDisplayChart() {
        if (this.isTopTrendsDataReady === true) {

            this.isTopRankChartReady = false;
            this.isTopTimeChartReady = false;


            // timese
            const gtRequest = new GlobalTrendsRequest();
            gtRequest.action = 'display';
            gtRequest.endpoint = 'topmarket';
            gtRequest.dataset_type = 'topmarket';
            gtRequest.graph = 'timeseries';
            gtRequest.username = localStorage.getItem('user_id');

            this.topTrendsTimeChartLoading = true;
            this.globaltrendsService
                .getGtOverview(gtRequest)
                .then(res => {
                    this.gtDataTopTime = res.result;
                    this.prepareTopTimeseries();
                })
                .catch(error => this.errorHandler(error));

            // ranking
            const gtRequest1 = new GlobalTrendsRequest();
            gtRequest1.action = 'display';
            gtRequest1.endpoint = 'topmarket';
            gtRequest1.dataset_type = 'topmarket';
            gtRequest1.graph = 'ranking';
            gtRequest1.username = localStorage.getItem('user_id');

            this.topTrendsRankChartLoading = true;
            this.globaltrendsService
                .getGtOverview(gtRequest1)
                .then(res => {
                    this.gtDataTopRank = res.result;
                    this.prepareTopRanking();
                })
                .catch(error => this.errorHandler(error));
        }
    }


    clickHistDisplayChart() {
        if (this.numberOfHistSuccessDataSet === this.histDatasetList.length + 1) {
            this.isHistChartReady = false;
            const gtRequest = new GlobalTrendsRequest();
            gtRequest.action = 'display';
            gtRequest.endpoint = 'historical';
            gtRequest.username = localStorage.getItem('user_id');

            this.historicalChartLoading = true;
            return this.globaltrendsService
                .getGtOverview(gtRequest)
                .then(res => {
                    this.gtDataHistorical = res.result;
                    this.prepareHistoricalChart();
                })
                .catch(error => this.errorHandler(error));
        }
    }


    prepareTopTimeseries() {

        this.topTimeData = [];
        this.topTimeLabels = [];
        let dataPoint = new DataPoint;
        const data = new Array<number>();
        let chartLabels = new Array<string>();

        const countryNameList = new Array<string>();


        this.gtDataTopTime.forEach(x => {
            countryNameList.indexOf(x.country_name) === -1 ? countryNameList.push(x.country_name) : undefined;
        });

        countryNameList.forEach(x => {
            dataPoint = new DataPoint;
            const eachData = new Array<number>();
            const eachLabels = new Array<string>();
            chartLabels = new Array<string>();

            const eachDataList = this.gtDataTopTime.filter(y => y.country_name === x);

            eachDataList.forEach(y => {
                eachData.push(y.de_per_capita);
                chartLabels.push(y.date);
            });
            dataPoint.data = eachData;
            dataPoint.label = x;
            dataPoint.fill = false;
            dataPoint.hidden = false;

            this.topTimeData.push(dataPoint);

        });
        console.log(this.topTimeData);
        this.topTimeLabels = chartLabels;
        this.topTrendsTimeChartLoading = false;
        this.isTopTimeChartReady = true;
    }

    prepareTopRanking() {
        this.topRankData = [];
        this.topRankLabels = [];
        const dataPoint = new DataPoint;
        const data = new Array<number>();
        const chartLabels = new Array<string>();
        this.gtDataTopRank.forEach(x => {
            chartLabels.push(x.country_name);
            data.push(x.de_per_capita);
        });
        dataPoint.data = data;
        dataPoint.backgroundColor = 'rgba(255,255,255,.3)';
        this.topRankData.push(dataPoint);
        this.topRankLabels = chartLabels;


        this.topTrendsRankChartLoading = false;
        this.isTopRankChartReady = true;
    }

    public barChart1Colours: Array<any> = [
        {
            backgroundColor: '#64abeb',
            borderColor: '#64abeb'
        },
        {
            backgroundColor: '#ba4e72',
            borderColor: '#ba4e72'
        },
        {
            backgroundColor: '#ea9423',
            borderColor: '#ea9423'
        },
        {
            backgroundColor: '#a967aa',
            borderColor: '#a967aa'
        },
        {
            backgroundColor: '#6db7a3',
            borderColor: '#6db7a3'
        },
        {
            backgroundColor: '#CCD65A',
            borderColor: '#CCD65A'

        },
        {
            backgroundColor: '#32B7BE',
            borderColor: '#32B7BE'
        },
        {
            backgroundColor: '#D169BD',
            borderColor: '#D169BD'
        },
        {
            backgroundColor: '#60C0E7',
            borderColor: '#60C0E7'
        },
        {
            backgroundColor: '#F386A2',
            borderColor: '#F386A2'
        }
    ];

    prepareHistoricalChart() {
        if (this.filterHistMarketList.filter(x => x === this.filterHistMarket).length === this.filterHistMarketList.length && this.isRegion(this.filterHistMarket) < 1) {
            this.isHistDexc = false;
        }
        if (this.isHistDexc === true) {
            this.lineChartOptions.scales.yAxes[0].scaleLabel.labelString = 'Demand Expressions per Capita';
        } else {
            this.lineChartOptions.scales.yAxes[0].scaleLabel.labelString = 'Demand Expressions';
        }

        this.lineChartData = [];
        this.lineChartLabels = [];
        const dataPoint = new DataPoint;
        const data = new Array<number>();
        if (this.numberOfHistSuccessDataSet > 1) {
            for (let i = 0; i < this.numberOfHistSuccessDataSet; i++) {
                const dataPoint = new DataPoint;
                const data = new Array<number>();
                const barChartLabels = new Array<string>();
                const id = i === 0 ? 'primary' : i - 1;
                let label = '';
                this.gtDataHistorical.forEach(x => {
                    x.dataset_id === id.toString() ? barChartLabels.push(this.handleDateLabel(x)) : undefined;
                    x.dataset_id === id.toString() ? label = x.market + ':' + x.genevalue : undefined;
                    x.dataset_id === id.toString() ? data.push(this.isHistDexc === true ? x.de_per_capita : x.real_de) : undefined;
                });
                dataPoint.data = data;
                dataPoint.fill = false;
                dataPoint.label = label;
                this.lineChartData.push(dataPoint);
                this.lineChartLabels.length === 0 ? this.lineChartLabels = barChartLabels : undefined;
            }
        } else {
            const barChartLabels = new Array<string>();
            this.gtDataHistorical.forEach(x => {
                barChartLabels.push(this.handleDateLabel(x));
                data.push(this.isHistDexc === true ? x.de_per_capita : x.real_de);
            });
            dataPoint.data = data;
            dataPoint.fill = false;
            this.lineChartData.push(dataPoint);
            this.lineChartLabels = barChartLabels;
        }

        console.log(this.lineChartData);
        console.log(this.chartLabel);
        this.historicalChartLoading = false;
        this.isHistChartReady = true;
    }

    handleDateLabel(globalTrends: GlobalTrends) {
        if (this.filterHistDateType === 'daily') {
            return globalTrends.date;
        } else if (this.filterHistDateType === 'weekly') {
            return globalTrends.year + ':' + globalTrends.week;
        } else if (this.filterHistDateType === 'monthly') {
            return globalTrends.year + ':' + globalTrends.month;
        }

    }
    updateGlobalTrends() {
        if (this.filterOverviewMarketList.length > 0 && this.filterOverviewMarketList.includes('Please Select Market')) {
            this.errorHandler('Please select market for additional country');
        }
        else {
            let dateOk = true;
            let marketOk = true;

            let dateFrom = new Date(this.filterDateFrom);
            let dateTo = new Date(this.filterDateTo);
            if (dateFrom > dateTo) {
                dateOk = false;
            }
            if (dateTo > this.todaysDate) {
                dateOk = false;
            }
            if (this.isRegion(this.filterMarket) === 2) {

                const date1 = new Date(this.filterDateTo);
                const refinedDate = new Date(date1.setMonth(date1.getMonth() - 1));

                if (refinedDate > dateFrom) {
                    marketOk = false;
                }
            } else if (this.isRegion(this.filterMarket) === 1) {
                const date2 = new Date(this.filterDateTo);
                const refinedDate = new Date(date2.setMonth(date2.getMonth() - 3));

                if (refinedDate > dateFrom) {
                    marketOk = false;
                }
            }

            for (let i = 0; i < this.overviewDatasetList.length; i++) {
                dateFrom = new Date(this.overviewDateFromList[i]);
                dateTo = new Date(this.overviewDateToList[i]);
                if (dateFrom > dateTo) {
                    dateOk = false;
                    break;
                }
                if (dateTo > this.todaysDate) {
                    dateOk = false;
                    break;
                }
                if (this.isRegion(this.filterOverviewMarketList[i]) === 2) {
                    const date1 = new Date(this.overviewDateToList[i]);
                    const refinedDate = new Date(date1.setMonth(date1.getMonth() - 1));

                    if (refinedDate > dateFrom) {
                        marketOk = false;
                        break;
                    }
                } else if (this.isRegion(this.filterOverviewMarketList[i]) === 1) {
                    const date1 = new Date(this.overviewDateToList[i]);
                    const refinedDate = new Date(date1.setMonth(date1.getMonth() - 3));

                    if (refinedDate > dateFrom) {
                        marketOk = false;
                        break;
                    }
                }
            }

            if (dateOk === false) {
                this.errorHandler('Date Error: Please check the selected dates');
            } else if (marketOk === false) {
                this.errorHandler('Main Region maximum date range is 1 month. Sub Region maximum date range is 3 months');
            }
            else {
                this.loadingTrends = true;
                this.isInformationEnabled = false;
                this.isDatasetBeingLoaded = true;
                this.chartLabel = undefined;
                this.isDisplayChartEnabled = false;
                this.isDexc = true;

                this.isMgChart = false;
                this.isNetworkChart = false;
                this.isCountryChart = false;
                this.isSgChart = false;

                this.mainGenreChartLoading = false;
                this.networkChartLoading = false;
                this.countryChartLoading = false;
                this.subgenreChartLoading = false;

                this.isMgChartReady = false;
                this.isSgChartReady = false;
                this.isNetworkChartReady = false;
                this.isCountryChartReady = false;

                if (this.filterChartGeneType === 'All') {
                    this.isMgChart = true;
                    this.isNetworkChart = true;
                    this.isCountryChart = true;
                    this.isSgChart = true;

                } else if (this.filterChartGeneType === 'Main Genre') {
                    this.isMgChart = true;
                } else if (this.filterChartGeneType === 'Sub Genre') {
                    this.isSgChart = true;
                } else if (this.filterChartGeneType === 'Orig. Country') {
                    this.isCountryChart = true;
                } else if (this.filterChartGeneType === 'Orig. Network') {
                    this.isNetworkChart = true;
                }
                this.isOverviewDistribution = this.filterDistribution === 'True' && this.filterOverviewMarketList.length > 0 ? true : false;
                this.loadingTopBottom = this.isOverviewDistribution ? true : false;
                this.numberOfSuccessDataSet = 0;
                const gtDeleteAllRequest = new GlobalTrendsRequest();
                gtDeleteAllRequest.action = 'delete_all';
                gtDeleteAllRequest.endpoint = 'overview';
                gtDeleteAllRequest.username = localStorage.getItem('user_id');
                this.globaltrendsService.createDataSet(gtDeleteAllRequest).then(res => {
                    // create primary dataset
                    const gtRequest = new GlobalTrendsRequest();
                    gtRequest.start_date = this.filterDateFrom;
                    gtRequest.end_date = this.filterDateTo;
                    gtRequest.market = this.handleMarket(this.filterMarket);
                    gtRequest.endpoint = 'overview';
                    gtRequest.aggregation = this.filterAggregation;
                    gtRequest.dataset_type = 'primary';
                    gtRequest.action = 'create';
                    gtRequest.username = localStorage.getItem('user_id');

                    if (this.filterOverviewGeneValue !== 'Please Select Value') {
                        this.portfolio = new portfolio();
                        this.portfolio.type = 'by_gene';
                        this.portfolio.value = [this.filterOverviewGeneValue];
                        gtRequest.portfolio = this.portfolio;
                    }

                    if (this.filterDistribution !== '100%') {
                        this.distribution = new distribution();
                        this.distribution.percentile = this.handleDistributionValue(this.filterDistribution);
                        this.distribution.type = this.handleDistributionType(this.filterDistribution);
                        gtRequest.distribution = this.distribution;

                    }

                    this.globaltrendsService
                        .createDataSet(gtRequest)
                        .then(res => {
                            this.numberOfSuccessDataSet = this.numberOfSuccessDataSet + 1;
                            this.addExtraDataSet();
                            this.isDisplayChartEnabled = true;
                            this.loadingTrends = false;

                        });
                });
            }
        }
    }
    addExtraDataSet() {
        for (let i = 0; i < this.overviewDatasetList.length; i++) {
            this.loadingTrends = true;
            const gtExtraDataRequest = new GlobalTrendsRequest();
            gtExtraDataRequest.start_date = this.overviewDateFromList[i];
            gtExtraDataRequest.end_date = this.overviewDateToList[i];
            gtExtraDataRequest.market = this.handleMarket(this.filterOverviewMarketList[i]);
            gtExtraDataRequest.endpoint = 'overview';
            gtExtraDataRequest.aggregation = this.filterAggregation;
            gtExtraDataRequest.dataset_type = '' + i;
            gtExtraDataRequest.action = 'create';
            gtExtraDataRequest.username = localStorage.getItem('user_id');


            if (this.filterOverviewSegGeneValueList[i] !== 'Please Select Value') {
                this.portfolio = new portfolio();
                this.portfolio.type = 'by_gene';
                this.portfolio.value = [this.filterOverviewSegGeneValueList[i]];
                gtExtraDataRequest.portfolio = this.portfolio;
            }


            if (this.filterOverviewDistributionList[i] !== '100%') {
                this.distribution = new distribution();
                this.distribution.percentile = this.handleDistributionValue(this.filterOverviewDistributionList[i]);
                this.distribution.type = this.handleDistributionType(this.filterOverviewDistributionList[i]);
                gtExtraDataRequest.distribution = this.distribution;
            }


            this.globaltrendsService.createDataSet(gtExtraDataRequest).then(res => {
                this.numberOfSuccessDataSet = this.numberOfSuccessDataSet + 1;
                this.loadingTrends = false;
            });
        }
    }
    handleMarket(market: any) {

        if (this.mainRegionList.findIndex(x => x.market === market) !== -1) {
            return 'major_region:' + market;
        } else if (this.subRegionList.findIndex(x => x.market === market) !== -1) {
            return 'sub_region:' + market;
        } else if (this.countryList.findIndex(x => x.market === market) !== -1) {
            return 'country:' + market;
        }
        else {
            return market;
        }
    }

    isRegion(market: any) {

        if (this.mainRegionList.findIndex(x => x.market === market) !== -1) {
            return 2;
        } else if (this.subRegionList.findIndex(x => x.market === market) !== -1) {
            return 1;
        } else if (this.countryList.findIndex(x => x.market === market) !== -1) {
            return 0;
        }
    }

    getGtOverview(dataType: string) {
        const gtRequest = new GlobalTrendsRequest();
        gtRequest.action = 'display';
        gtRequest.top = this.filterTopNumber;
        gtRequest.endpoint = 'overview';
        gtRequest.username = localStorage.getItem('user_id');

        if ((this.filterOverviewMarketList.filter(x => x === this.filterMarket).length === this.filterOverviewMarketList.length)
            && this.isRegion(this.filterMarket) < 1) {
            this.isDexc = false;
        }

        if (this.isDexc === true) {
            if (this.filterAggregation === 'mean') {
                this.chartLabel = 'Average. Demand Expression Per Capita';
            } else {
                this.chartLabel = 'Sum. Demand Expression Per Capita';
            }
        } else {
            if (this.filterAggregation === 'mean') {
                this.chartLabel = 'Average. Demand Expressions';
            } else {
                this.chartLabel = 'Sum. Demand Expressions';
            }
        }

        if (dataType === 'genre') {
            gtRequest.genetype = dataType;
            return this.globaltrendsService
                .getGtOverview(gtRequest)
                .then(res => {
                    this.gtDataMG = res.result;
                    this.prepareMainGenreChart();
                    this.loadingTopBottom = false;
                })
                .catch(error => this.errorHandler(error));
        }
        if (dataType === 'subgenre') {
            gtRequest.genetype = dataType;
            return this.globaltrendsService
                .getGtOverview(gtRequest)
                .then(res => {
                    this.gtDataSG = res.result;
                    this.prepareSubgenreChart();
                    this.loadingTopBottom = false;
                })
                .catch(error => this.errorHandler(error));
        }
        if (dataType === 'country') {
            gtRequest.genetype = dataType;
            return this.globaltrendsService
                .getGtOverview(gtRequest)
                .then(res => {
                    this.gtDataCountry = res.result;
                    this.prepareCountryChart();
                    this.loadingTopBottom = false;
                })
                .catch(error => this.errorHandler(error));
        }
        if (dataType === 'network') {
            gtRequest.genetype = dataType;
            return this.globaltrendsService
                .getGtOverview(gtRequest)
                .then(res => {
                    this.gtDataNetwork = res.result;
                    this.prepareNetworkChart();
                    this.loadingTopBottom = false;
                })
                .catch(error => this.errorHandler(error));
        }
    }
    prepareMainGenreChart() {
        this.mgChartData = [];
        this.mgChartLabels = [];
        const dataPoint = new DataPoint;
        const data = new Array<number>();
        if (this.numberOfSuccessDataSet > 1) {
            for (let i = 0; i < this.numberOfSuccessDataSet; i++) {
                const dataPoint = new DataPoint;
                const data = new Array<number>();
                const barChartLabels = new Array<string>();
                const id = i === 0 ? 'primary' : i - 1;
                let label = '';
                if (i !== 0) {
                    label = this.filterOverviewMarketList[id] + '=' + this.overviewDateFromList[id] + '~' + this.overviewDateToList[id];
                } else {
                    label = this.filterMarket + '=' + this.filterDateFrom + '~' + this.filterDateTo;
                }
                this.gtDataMG.forEach(x => {
                    x.dataset_id === id.toString() ? barChartLabels.push(x.genevalue) : undefined;
                    x.dataset_id === id.toString() ? data.push(this.isDexc === true ? x.de_per_capita : x.real_de) : undefined;
                });
                dataPoint.data = data;
                dataPoint.label = label;
                this.mgChartData.push(dataPoint);
                this.mgChartLabels.length === 0 ? this.mgChartLabels = barChartLabels : undefined;
                this.mgChartLegend = true;
            }
        } else {
            const barChartLabels = new Array<string>();
            this.gtDataMG.forEach(x => {
                barChartLabels.push(x.genevalue);
                data.push(this.isDexc === true ? x.de_per_capita : x.real_de);
            });
            dataPoint.data = data;
            this.mgChartData.push(dataPoint);
            this.mgChartLabels = barChartLabels;
        }
        this.mainGenreChartLoading = false;
        this.isMgChartReady = true;
    }


    prepareNetworkChart() {
        this.networkChartData = [];
        this.networkChartLabels = [];
        const dataPoint = new DataPoint;
        const data = new Array<number>();
        if (this.numberOfSuccessDataSet > 1) {
            for (let i = 0; i < this.numberOfSuccessDataSet; i++) {
                const dataPoint = new DataPoint;
                const data = new Array<number>();
                const barChartLabels = new Array<string>();
                const id = i === 0 ? 'primary' : i - 1;
                let label = '';
                if (i !== 0) {
                    label = this.filterOverviewMarketList[id] + '=' + this.overviewDateFromList[id] + '~' + this.overviewDateToList[id];
                } else {
                    label = this.filterMarket + '=' + this.filterDateFrom + '~' + this.filterDateTo;
                }
                this.gtDataNetwork.forEach(x => {
                    x.dataset_id === id.toString() ? barChartLabels.push(x.genevalue) : undefined;
                    x.dataset_id === id.toString() ? data.push(this.isDexc === true ? x.de_per_capita : x.real_de) : undefined;
                });
                dataPoint.data = data;
                dataPoint.label = label;
                this.networkChartData.push(dataPoint);
                this.networkChartLabels.length === 0 ? this.networkChartLabels = barChartLabels : undefined;
                this.networkChartLegend = true;
            }
        } else {
            const barChartLabels = new Array<string>();
            this.gtDataNetwork.forEach(x => {
                barChartLabels.push(x.genevalue);
                data.push(this.isDexc === true ? x.de_per_capita : x.real_de);
            });
            dataPoint.data = data;
            this.networkChartData.push(dataPoint);
            this.networkChartLabels = barChartLabels;
        }
        this.networkChartLoading = false;
        this.isNetworkChartReady = true;

    }
    prepareCountryChart() {
        this.countryChartData = [];
        this.countryChartLabels = [];
        const dataPoint = new DataPoint;
        const data = new Array<number>();
        if (this.isDexc === true) {

        }
        if (this.numberOfSuccessDataSet > 1) {
            for (let i = 0; i < this.numberOfSuccessDataSet; i++) {
                const dataPoint = new DataPoint;
                const data = new Array<number>();
                const barChartLabels = new Array<string>();
                const id = i === 0 ? 'primary' : i - 1;
                let label = '';
                if (i !== 0) {
                    label = this.filterOverviewMarketList[id] + '=' + this.overviewDateFromList[id] + '~' + this.overviewDateToList[id];
                } else {
                    label = this.filterMarket + '=' + this.filterDateFrom + '~' + this.filterDateTo;
                }
                this.gtDataCountry.forEach(x => {
                    x.dataset_id === id.toString() ? barChartLabels.push(x.country_name_x) : undefined;
                    x.dataset_id === id.toString() ? data.push(this.isDexc === true ? x.de_per_capita : x.real_de) : undefined;
                });
                dataPoint.data = data;
                dataPoint.label = label;
                this.countryChartData.push(dataPoint);
                this.countryChartLabels.length === 0 ? this.countryChartLabels = barChartLabels : undefined;
                this.countryChartLegend = true;
            }
        } else {
            const barChartLabels = new Array<string>();
            this.gtDataCountry.forEach(x => {
                barChartLabels.push(x.country_name_x);
                data.push(this.isDexc === true ? x.de_per_capita : x.real_de);
            });
            dataPoint.data = data;
            this.countryChartData.push(dataPoint);
            this.countryChartLabels = barChartLabels;
        }
        this.countryChartLoading = false;
        this.isCountryChartReady = true;
    }

    prepareSubgenreChart() {
        this.sgChartData = [];
        this.sgChartLabels = [];
        const dataPoint = new DataPoint;
        const data = new Array<number>();
        if (this.numberOfSuccessDataSet > 1) {
            for (let i = 0; i < this.numberOfSuccessDataSet; i++) {
                const dataPoint = new DataPoint;
                const data = new Array<number>();
                const barChartLabels = new Array<string>();
                const id = i === 0 ? 'primary' : i - 1;
                let label = '';
                if (i !== 0) {
                    label = this.filterOverviewMarketList[id] + '=' + this.overviewDateFromList[id] + '~' + this.overviewDateToList[id];
                } else {
                    label = this.filterMarket + '=' + this.filterDateFrom + '~' + this.filterDateTo;
                }
                this.gtDataSG.forEach(x => {
                    x.dataset_id === id.toString() ? barChartLabels.push(x.genevalue) : undefined;
                    x.dataset_id === id.toString() ? data.push(this.isDexc === true ? x.de_per_capita : x.real_de) : undefined;
                });
                dataPoint.data = data;
                dataPoint.label = label;
                this.sgChartData.push(dataPoint);
                this.sgChartLabels.length === 0 ? this.sgChartLabels = barChartLabels : undefined;
                this.sgChartLegend = true;
            }
        } else {
            const barChartLabels = new Array<string>();
            this.gtDataSG.forEach(x => {
                barChartLabels.push(x.genevalue);
                data.push(this.isDexc === true ? x.de_per_capita : x.real_de);
            });
            dataPoint.data = data;
            this.sgChartData.push(dataPoint);
            this.sgChartLabels = barChartLabels;
        }
        this.subgenreChartLoading = false;
        this.isSgChartReady = true;
    }


    clickInformation(type: string) {
        const gtRequest = new GlobalTrendsRequest();
        gtRequest.action = 'infobox';
        gtRequest.genetype = type;
        gtRequest.endpoint = 'overview';
        console.log(type);
        gtRequest.username = localStorage.getItem('user_id');
        this.globaltrendsService
            .getGtOverview(gtRequest)
            .then(res => {
                console.log(res.result);
                if (type === 'genre') {
                    this.mgInfo = res.result;
                    console.log(this.mgInfo);
                } else if (type === 'subgenre') {
                    this.sgInfo = res.result;
                }
                this.isInformationEnabled = true;
            });
    }
    // events
    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }

    // events
    public rankChartClicked(e: any): void {
        console.log(e);
        const index = undefined;
        if (e.active.length > 0) {
            for (let i = 0; i < this.topTimeData.length; i++) {
                if (i === e.active[0]._index) {
                    this.topTimeData[i].hidden = false;
                } else {
                    this.topTimeData[i].hidden = true;
                }
            }
        } else {
            this.topTimeData.forEach(x => x.hidden = false);
        }
        this.isTopTimeChartReady = false;

        setTimeout(() => {
            this.isTopTimeChartReady = true;
        }, 1);
    }





    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['top', 'right']
    };

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                this._service.success(this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        this.notificationContent = error;
        this.createNotification();
    }

    isAdded(i: any) {
        return false;
    }

    handleDistributionValue(distribution: string) {
        if (distribution.startsWith('Top')) {
            return +distribution.replace('Top:', '').replace('%', '');
        } else if (distribution.startsWith('Bottom')) {
            const val = +distribution.replace('Bottom:', '').replace('%', '');
            return 100 - val;
        }
    }

    handleDistributionType(distribution: string) {
        if (distribution.startsWith('Top')) {
            return 'top';
        } else if (distribution.startsWith('Bottom')) {
            return 'bottom';
        }
    }


}


// WEBPACK FOOTER //
// ./src/app/globaltrends/globaltrends.component.ts